var exports = {
  "wI": "WhatsNewModal.module__whatsNewRoot___OE1ySX",
  "UT": "WhatsNewModal.module__contentShell___OE1ySX",
  "N4": "WhatsNewModal.module__coverImage___OE1ySX",
  "yp": "WhatsNewModal.module__contentBody___OE1ySX",
  "hZ": "WhatsNewModal.module__dateLine___OE1ySX",
  "eM": "WhatsNewModal.module__markdownBody___OE1ySX",
  "qr": "WhatsNewModal.module__footer___OE1ySX",
  "GZ": "WhatsNewModal.module__blueskyLink___OE1ySX",
  "$Y": "WhatsNewModal.module__blueskyIcon___OE1ySX",
  "r": "WhatsNewModal.module__dismissButton___OE1ySX",
  "T7": "WhatsNewModal.module__scrollHint___OE1ySX",
  "LL": "WhatsNewModal.module__scrollHintVisible___OE1ySX",
  "HF": "WhatsNewModal.module__scrollHintCircle___OE1ySX",
  "ki": "WhatsNewModal.module__scrollHintPulse___OE1ySX",
};

module.exports = exports;
